import { createWave, play, pause } from './path-wave';

const $ribbons = document.querySelectorAll('.ribbon');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const waveDefaults = { amplitude: 6, length: 600, duration: 6000 };

if ($ribbons.length && !reducedMotion.matches) {
    const waves = new Map();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const $ribbon = entry.target;
            const wave = waves.get($ribbon);

            if (entry.intersectionRatio >= 0.3) {
                $ribbon.classList.add('is-visible');
            }
            if (entry.isIntersecting && $ribbon.classList.contains('is-drawn')) {
                play(wave);
            } else {
                pause(wave);
            }
        });
    }, { threshold: [0, 0.3] });

    $ribbons.forEach(($ribbon) => {
        waves.set($ribbon, createWave($ribbon, waveDefaults));
        $ribbon.classList.add('is-animated');

        $ribbon.addEventListener('transitionend', (event) => {
            const isDrawn = $ribbon.classList.contains('is-drawn');

            if (event.propertyName === 'stroke-dashoffset' && !isDrawn) {
                $ribbon.classList.add('is-drawn');
                play(waves.get($ribbon));
            }
        });

        observer.observe($ribbon);
    });
}
